import React from "react";
import {
  addChatSimult,
  addChat,
  typingadd,
  TransferCall,
  createStatusAgent,
} from "../actions";
import { connect } from "react-redux";
import {
  SendSocketTransferCallIn,
  SendSocketTransferClient,
} from "../actions/websocket";
import { Popover } from "../actions/Tippy";
import Moment from "moment";
import _ from "lodash";
import { ReactComponent as Arrow } from "../build/images/account-arrow-right.svg";
import { ReactComponent as IconConsultTransfer } from "../build/images/attendanceIcons/arrow-swap.svg";

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    InitialChat: (iduser, displayname, view, ramal) => {
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      dispatch(
        addChatSimult(iduser, displayname, true, false, ramal, datatime),
      );
      dispatch(addChat(iduser, displayname, true, false, ramal, datatime));
      dispatch(typingadd(iduser, displayname));
    },
    TransferCall: (user) => {
      dispatch(TransferCall(user));
    },
    byeCallForce: (user) => {
      dispatch(
        createStatusAgent(
          "Encerrou",
          "Encerrou",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    },
    sendSocketActionTransferCall: (
      infousers,
      ContactId,
      agent,
      atdsimult,
      outservices,
      servicegroup,
      ipcurrent,
    ) => {
      const socket = SendSocketTransferCallIn(
        infousers,
        ContactId,
        agent,
        atdsimult,
        outservices,
        servicegroup,
        dispatch,
        ipcurrent,
      );
    },
  };
};

const mapStateToProps = (state) => {
  return {
    UserGroups: state.groups,
    InfoUsers: state.informationusers,
    ContactId: state.atendimento,
    ChatSimult: state.chatsimult,
    UsersAgents: state.agents,
    AtdSimult: state.atdsimult,
    StatusAgent: state.status,
    IPCurrent: state.ipcurrent,
  };
};

class AgentButton extends React.Component {
  constructor(props) {
    var storageGroup = localStorage.getItem("atendance_filter_group") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);
    }

    var storageState = localStorage.getItem("atendance_filter_state") || [];
    if (storageState.length !== 0) {
      storageState = storageState.split(",");
    }

    super(props);
    this.state = {
      buttonfilterConsulted: false,
      keyGen: storageGroup,
      auxkeyGen: storageGroup,
      keyGan: storageState,
      auxkeyGan: storageState,
      marked: "Marcar Todos",
      checked: false,
      groups: [],
      agents: [],
      agentsinicial: [],
      expandAgent: [],
      showtransfer: "atendentes",
      atdsimult: [],
      filterAgent: "",
      isTransfering: false,
    };
  }

  componentDidMount() {
    this.setState({ filterGroup: "" });
  }

  componentWillUnmount() {
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout); // cancela caso o componente seja desmontado
    }
  }

  DisplayFilterConsulted(e) {
    e.preventDefault();
    this.setState({ buttonfilterConsulted: !this.state.buttonfilterConsulted });
  }

  filterState(e, status) {
    let filterstatestorage = [];
    if (e.target.checked) {
      filterstatestorage = this.state.keyGan.concat([status]);
      if (status === "AT")
        filterstatestorage = filterstatestorage.concat(["ATOS"]);
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
    } else {
      filterstatestorage = this.state.keyGan.filter(function (val) {
        return val != status;
      });
      if (status === "AT")
        filterstatestorage = filterstatestorage.filter(function (val) {
          return val != "ATOS";
        });
      this.setState({
        keyGan: filterstatestorage,
      });
      this.setState({
        auxkeyGan: filterstatestorage,
      });
    }
    localStorage.setItem("atendance_filter_state", filterstatestorage);
  }

  checkExpandAgent(e, idchatsimult) {
    var checkClick =
      this.state.expandAgent.indexOf(idchatsimult) != -1 ? true : false;
    // Descomentar e excluir a de baixo depois que for resolvido o css, deixar igual o do facebook
    // if (!checkClick){
    //   this.setState({
    //     expandAgent: this.state.expandAgent.concat([idchatsimult])
    //   })
    // } else {
    //   this.setState({
    //     expandAgent : this.state.expandAgent.filter(function(val) {return val!=idchatsimult})
    //   })
    // }
    if (!checkClick) {
      this.setState({
        expandAgent: [idchatsimult],
      });
      this.setState({ chatatual: idchatsimult });
    } else {
      this.setState({
        expandAgent: this.state.expandAgent.filter(function (val) {
          return val != idchatsimult;
        }),
      });
      this.setState({ chatatual: 0 });
    }
  }

  TransferAgent(
    event,
    infousers,
    ContactId,
    agent,
    atdsimult,
    Messages,
    outservices,
    servicegroup,
    ipcurrent,
  ) {
    if (infousers.id) {
      // delete mensagensnaolidas[ContactId.idatendimento];
      // delete outroatendimento[ContactId.idatendimento];
      if (ContactId.length != 0) {
        this.props.sendSocketActionTransferCall(
          infousers,
          ContactId,
          agent,
          atdsimult,
          outservices,
          servicegroup,
          ipcurrent,
        );
        // const socket = SendSocketTransferCallIn(
        //   infousers,
        //   ContactId,
        //   agent,
        //   atdsimult,
        //   outservices,
        //   servicegroup
        // );
      } else {
        this.props.ByeAttendant(ContactId, infousers, "transferencia");
      }
    }
    document.getElementById("simulation_click").click();
    if (Messages === "1") {
    }
    this.props.TransferCall(infousers);
  }

  changeAgent(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ keyGan: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGan: this.state.auxkeyGan });
    }
  }

  filterGroup(e, idgroup) {
    let filtersgroupstorage = [];
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup]),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup]),
      });
      filtersgroupstorage = this.state.keyGen.concat([idgroup]);
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      filtersgroupstorage = this.state.keyGen.filter(function (val) {
        return val != idgroup;
      });
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
    }
    localStorage.setItem("atendance_filter_group", filtersgroupstorage);
  }

  filterGroupAll(e, usergroups) {
    var usergroups = usergroups.groups;
    var teste = [];
    if (e.target.checked) {
      this.setState({ checked: true });
      this.setState({ marked: "Desmarcar Todos" });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = true;
      for (let i = 0; i < usergroups.length; i++) {
        teste.push(usergroups[i].id);
        var myCheckbox = document.getElementById("groups" + usergroups[i].id);
        myCheckbox.checked = true;
      }
      this.setState({
        keyGen: teste,
      });
    } else {
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = false;
      usergroups.map((groups) => {
        var myCheckbox = document.getElementById("groups" + groups.id);
        myCheckbox.checked = false;
      });
      this.setState({ keyGen: [] });
    }
  }

  InitialChatConsult(e, chatsimult, user) {
    let erro = 0;
    if (chatsimult.length != 0) {
      chatsimult.forEach((chat) => {
        if (parseInt(chat.iduserout) === parseInt(user.iduser)) {
          erro = 1;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
      } else {
        this.props.InitialChat(
          parseInt(user.iduser),
          user.label,
          "0",
          user.ramal,
        );
      }
    } else {
      this.props.InitialChat(
        parseInt(user.iduser),
        user.label,
        "0",
        user.ramal,
      );
    }
    document.getElementById("simulation_click").click();
    this.checkExpandAgent(e, user.iduser);
  }

  handleShow(e, value) {
    this.setState({ showtransfer: value === "clientes" ? false : true });
    if (value === "clientes") {
      document.getElementById("radio-1").checked = true;
      document.getElementById("radio-2").checked = false;
    } else {
      document.getElementById("radio-2").checked = true;
      document.getElementById("radio-1").checked = false;
    }
  }

  TransferClient(e, simult, ContactId) {
    try {
      const contactIdString = JSON.stringify(ContactId);
      console.log("INGENIUM_VOICE_TRANSF", contactIdString);
    } catch (error) {
      console.log("INGENIUM_VOICE_TRANSF_ERROR", error);
      console.log("INGENIUM_VOICE_TRANSF_ERROR_1", ContactId);
    }
    const socket = SendSocketTransferClient(simult, ContactId);
    document.getElementById("simulation_click").click();
    // setTimeout(() => {
    //   this.props.byeCallForce();
    // }, 500)
  }

  renderPopover = (
    e,
    UserGroups,
    ContactId,
    InfoUsers,
    ChatSimult,
    AtdSimult,
    ipcurrent,
  ) => (
    <div id="popover-check-friend">
      <div className="popover">
        <div className="popover__header">
          <i className="fas fa-user"></i>
          <span>Gostaria de consultar algum operador?</span>
        </div>
        <div className="popover__body popover__body--full-width">
          <div
            className={
              this.state.buttonfilterConsulted
                ? "select with-icons with-footer-actions active"
                : "select with-icons with-footer-actions"
            }
          >
            <button
              type="button"
              data-pausa="Atendimento Presencial Cliente"
              onClick={this.DisplayFilterConsulted.bind(this)}
            >
              Filtros{" "}
            </button>
            <div className="options">
              <ul>
                <li>
                  <input
                    type="radio"
                    defaultChecked
                    name="filterGroup"
                    id="filterGroup"
                  />
                  <label htmlFor="filterGroup">Grupo</label>
                </li>
                <li>
                  <hr></hr>
                </li>
                <li>
                  <input
                    type="checkbox"
                    defaultChecked={
                      this.state.keyGan.findIndex(function (val) {
                        return val === "LV";
                      }) !== -1
                        ? true
                        : false
                    }
                    name="filtro1"
                    onChange={(event) => this.filterState(event, "LV")}
                    id="filtro1"
                  />{" "}
                  <label htmlFor="filtro1">Usuários Disponíveis</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    defaultChecked={
                      this.state.keyGan.findIndex(function (val) {
                        return val === "AT";
                      }) !== -1
                        ? true
                        : false
                    }
                    name="filtro3"
                    onChange={(event) => this.filterState(event, "AT")}
                    id="filtro3"
                  />{" "}
                  <label htmlFor="filtro3">Usuários em Atendimento</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    name="filtro4"
                    defaultChecked={
                      this.state.keyGan.findIndex(function (val) {
                        return val === "BQ";
                      }) !== -1
                        ? true
                        : false
                    }
                    onChange={(event) => this.filterState(event, "BQ")}
                    id="filtro4"
                  />{" "}
                  <label htmlFor="filtro4">Usuários Pausados</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    name="filtro5"
                    defaultChecked={
                      this.state.keyGan.findIndex(function (val) {
                        return val === "null";
                      }) !== -1
                        ? true
                        : false
                    }
                    onChange={(event) => this.filterState(event, "null")}
                    id="filtro5"
                  />{" "}
                  <label htmlFor="filtro5">Usuários Deslogados</label>
                </li>
                <li>
                  <hr></hr>
                </li>
                <li>
                  <input
                    type="checkbox"
                    checked={this.state.checked}
                    name="groups0"
                    id="groups0"
                    onChange={(event) => this.filterGroupAll(event, UserGroups)}
                  />{" "}
                  <label htmlFor="groups0">{this.state.marked}</label>
                </li>
                {this.state.groups.map((group, index) => (
                  <li key={index}>
                    <input
                      type="checkbox"
                      onChange={(event) => this.filterGroup(event, group.id)}
                      name={"groups" + group.id}
                      id={"groups" + group.id}
                      defaultChecked={
                        this.state.keyGen.findIndex(function (val) {
                          return val === group.id;
                        }) !== -1
                          ? true
                          : false
                      }
                    />{" "}
                    <label htmlFor={"groups" + group.id}>{group.name}</label>
                  </li>
                ))}
                <a
                  className="btn btn-primary"
                  id="check-friend-apply-filters"
                  onClick={this.DisplayFilterConsulted.bind(this)}
                >
                  Close
                </a>
              </ul>
              {/* checked={this.state.checked && this.state.checking === group.id  ? true : false}  */}
            </div>
          </div>
          {(() => {
            if (ContactId.idmidia === "1" || ContactId.idmidia === "16") {
              return (
                <>
                  <div className="popover__see-list">Ver lista de:</div>
                  <div className="radio-content radio-content--popover">
                    <div className="radio-button radio-client">
                      <input
                        type="radio"
                        id="radio-1"
                        name="radio-1"
                        onClick={(event) => this.handleShow(event, "clientes")}
                      />
                      <label htmlFor="radio-1">
                        <span>
                          <div className="mask"></div>
                        </span>

                        <div className="text">Atendimentos</div>
                      </label>
                    </div>

                    <div className="radio-button radio-atendente">
                      <input
                        type="radio"
                        id="radio-2"
                        name="radio-2"
                        onClick={(event) =>
                          this.handleShow(event, "atendentes")
                        }
                        defaultChecked={
                          this.showtransfer === "atendentes" ? "true" : "false"
                        }
                      />
                      <label htmlFor="radio-2">
                        <span>
                          <div className="mask"></div>
                        </span>

                        <div className="text">Operadores</div>
                      </label>
                    </div>
                  </div>
                </>
              );
            }
          })()}

          <div className="full-search">
            <input
              type="text"
              name="client-search"
              id="client-search"
              onChange={(event) => this.changeAgent(event, "teste")}
              placeholder="Pesquisar..."
            />
            <button type="submit">
              <i className="fas fa-search"></i>
            </button>
          </div>
          <div
            className={
              this.state.showtransfer
                ? "popover__clientes clts active"
                : "popover__clientes clts"
            }
          >
            <div className="list">
              <ul>
                {this.state.agents.map((agent, index) => (
                  <li key={index}>
                    <div className="photo"></div>
                    <div className="data">
                      <div
                        className="name"
                        onClick={(event) =>
                          this.InitialChatConsult(event, ChatSimult, agent)
                        }
                      >
                        {agent.username}
                      </div>
                      <div
                        className="info"
                        key={agent.id}
                        onClick={(event) =>
                          this.InitialChatConsult(event, ChatSimult, agent)
                        }
                      >
                        <span>
                          <strong>Ramal:</strong> {agent.ramal}
                        </span>
                        <span>
                          <strong>Grupo:</strong> {agent.desc_grupo}
                        </span>
                        {(() => {
                          if (
                            agent.status_sip === null ||
                            agent.status === null
                          ) {
                            return (
                              <span>
                                <strong>Status:</strong> Deslogado
                              </span>
                            );
                          } else if (
                            agent.status_sip === "LV" &&
                            agent.status === "LV"
                          ) {
                            return (
                              <span>
                                <strong>Status:</strong> Livre
                              </span>
                            );
                          } else if (
                            agent.status_sip === "LV" &&
                            agent.status === "AT"
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> Atendimento
                                </span>
                                <span>
                                  <strong>Ocupação:</strong> {agent.direcao} com{" "}
                                  {agent.speaknum}
                                </span>
                              </div>
                            );
                          } else if (
                            agent.status_sip === "RV" &&
                            agent.status === "ATOS"
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> Atendimento
                                </span>
                                <span>
                                  <strong>Ocupação:</strong> {agent.direcao} com{" "}
                                  {agent.speaknum}
                                </span>
                              </div>
                            );
                          } else if (
                            agent.status_sip === "LV" &&
                            agent.status === "RV"
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> Discando
                                </span>
                                <span>
                                  <strong>Ocupação:</strong> {agent.direcao}{" "}
                                  para {agent.speaknum}
                                </span>
                              </div>
                            );
                          } else if (
                            agent.status_sip === "BQ" &&
                            agent.razao_bloqueio != ""
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> Pausado
                                </span>
                                <span>
                                  <strong>Ocupação:</strong> Pausa{" "}
                                  {agent.razao_bloqueio}
                                </span>
                              </div>
                            );
                          } else if (
                            agent.status_sip === "ACW" &&
                            agent.status === "ACW"
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> AfterCallWork
                                </span>
                                <span>
                                  <strong>Telefone:</strong>
                                  {agent.razao_bloqueio}
                                </span>
                              </div>
                            );
                          } else if (
                            agent.status_sip === "CHND" &&
                            agent.razao_bloqueio != "CHND"
                          ) {
                            return (
                              <div>
                                <span>
                                  <strong>Status:</strong> Chamando
                                </span>
                                <span>
                                  <strong>Ocupação:</strong> Chamando{" "}
                                  {agent.direcao} do {agent.speaknum}
                                </span>
                              </div>
                            );
                          }
                        })()}
                      </div>
                    </div>
                    {(() => {
                      if (agent.status_sip === "LV" && agent.status === "LV") {
                        return (
                          <div className="action">
                            <a
                              data-tooltip-content="Encaminhar conversa"
                              className="tippy-default"
                              TransferAgent
                              onClick={(event) => {
                                if (this.state.isTransfering) return;
                                this.setState({ isTransfering: true });

                                this.TransferAgent(
                                  event,
                                  InfoUsers,
                                  ContactId,
                                  agent,
                                  this.state.atdsimult,
                                  this.state.messages,
                                  this.state.outservices,
                                  this.state.servicegroup,
                                  ipcurrent,
                                );

                                this.throttleTimeout = setTimeout(() => {
                                  this.setState({ isTransfering: false });
                                }, 3000);
                              }}
                            >
                              <i className="material-icons">phone_forwarded</i>
                            </a>
                          </div>
                        );
                      }
                    })()}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={
              this.state.showtransfer
                ? "popover__clientes clts"
                : "popover__clientes clts active"
            }
          >
            <div className="list">
              <ul>
                {AtdSimult.map((simult, index) => (
                  <li
                    key={index}
                    style={{
                      display:
                        parseInt(simult.idatendimento) !==
                          parseInt(ContactId.idatendimento) &&
                        (parseInt(ContactId.idmidia) === 1 ||
                          parseInt(ContactId.idmidia) === 16)
                          ? "flex"
                          : "none",
                    }}
                  >
                    {/* && simult.idmidia === 1 */}
                    <div className="photo"></div>
                    <div className="data">
                      <div className="name">{createJSON(simult.cliente)}</div>
                      <div className="info">
                        <span>
                          <strong>Telefone:</strong> {simult.telefone}
                        </span>
                        {/* <span><strong>Grupo:</strong> Telemarketing</span>
                          <span><strong>Atendendo:</strong> André Luiz Batista Santana de Aureliano</span> */}
                      </div>
                    </div>
                    <div className="action">
                      {/* <div className="action__item tippy-default" alt="Consultar por voz" data-tippy-placement="bottom" data-tippy-content="Consultar por voz">
                          <i className="material-icons">phone</i>
                        </div> */}

                      <div
                        onClick={(event) =>
                          this.TransferClient(event, simult, ContactId)
                        }
                        className="action__item tippy-default"
                        alt="Encaminhar"
                        data-tippy-placement="bottom"
                        data-tippy-content="Consultar por voz"
                      >
                        <Arrow />
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const {
      ContactId,
      UserGroups,
      InfoUsers,
      ChatSimult,
      UsersAgents,
      AtdSimult,
      StatusAgent,
      IPCurrent,
    } = this.props;

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    if (UsersAgents.length != 0) {
      this.state.agents = UsersAgents;
      if (this.state.keyGen != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGen.includes(agent.id_grupo),
        );
      }
      if (this.state.keyGan != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status_sip),
        );
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status),
        );
      }
    }

    this.state.atdsimult = AtdSimult;

    const list2 = this.state.atdsimult || [];
    // this.state.atdsimult = _.filter(list2, (atd) => {
    //   let arrayAtd = [atd.cliente, atd.telefone];
    //   return !_.isEmpty(this.state.filterAgent)
    //     ? arrayAtd
    //         .toString()
    //         .toLowerCase()
    //         .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
    //     : true;
    // });

    if (UsersAgents.length != 0) {
      this.state.agents = UsersAgents;
      if (this.state.keyGen != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGen.includes(agent.id_grupo),
        );
      }
      if (this.state.keyGan != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status_sip),
        );
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status),
        );
      }
    }

    if (this.state.filterAgent !== "") {
      const list = UsersAgents || [];
      this.state.agents = list;
      this.state.agents = _.filter(list, (agent) => {
        let arrayAgent = [
          agent.username,
          agent.desc_grupo,
          agent.ramal,
          agent.razao_bloqueio,
        ];
        return !_.isEmpty(this.state.filterAgent)
          ? arrayAgent
              .toString()
              .toLowerCase()
              .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
          : true;
      });
    }

    this.state.agents = this.state.agents.filter(
      (agent) => agent.iduser !== InfoUsers.id,
    );

    return (
      <Popover
        trigger="click"
        interactive={true}
        content={this.renderPopover(
          this,
          UserGroups,
          ContactId,
          InfoUsers,
          ChatSimult,
          this.state.atdsimult,
          IPCurrent,
        )}
      >
        <button
          type="button"
          className="btn action with-icon with-dropdown tippy-popover not-clicable-tooltip"
          id="chat-action-check-friend"
          data-template="popover-check-friend"
          data-tooltip="Consulta / Transferencia"
          style={{
            display: StatusAgent.status !== "Aftercallwork" ? "" : "none",
          }}
        >
          {/* <i className="material-icons">people</i> */}
          <IconConsultTransfer />
        </button>
      </Popover>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentButton);
